import { render, staticRenderFns } from "./jhi-footer.vue?vue&type=template&id=4ec47f0c"
import script from "./jhi-footer.component.ts?vue&type=script&lang=ts&external"
export * from "./jhi-footer.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports